import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const PurchaseOrderDashboard = lazyLoader(
  () =>
    import(
      "Containers/PurchaseOrder/PurchaseOrderDashboard/PurchaseOrderDashboard"
    )
);

export const PurchaseOrder = () => {
  return (
    <Layout>
      <PurchaseOrderDashboard />
    </Layout>
  );
};
